import { useState } from 'react';
import HeaderSelect, { HeaderSelectType } from '../header-select/HeaderSelect';
import React, { useContext } from 'react';
import styles from './HeaderControls.module.scss';
import { AppContext } from '../../context/AppContext';
import * as _ from 'lodash';
import { IPlan } from '../../interfaces/IPlan';

const HeaderControls = () => {
  const appContext = useContext(AppContext);
  //console.log('appContext->'+JSON.stringify(appContext));
  const plansWithUniqueStates: IPlan[] = _.uniqBy(appContext.plansData, 'state');
  return (
    <>
      <div className={styles.headerControls}>
        {}
		<span>Para español, use Google Chrome y Google Translate</span><br/><br/>
		<span>
			<span className="plan_name_text"><b>{appContext.shortPlanName} </b></span> 
				<span className="common_text">services</span>&nbsp;
				<span className="common_text">state(s):&nbsp;</span>
				<span className="state_list_text">
					{plansWithUniqueStates.map((planData, i, arr) => (<span>{planData.state}{i != (arr.length-1) &&  (arr.length-1 != 0) ? ', ' : ''}</span>))}
				</span>&nbsp;
		</span>
		<br/>
		<span className="state_hint_span">
			<span className="disclaimer_hdr">Disclaimer</span> 
			<span className="disclaimer_mand"> *  </span>&nbsp;
			<span className="disclaimer_text">For more refined search, use ZIP code</span>
		</span>
		
      </div>

     
    </>
  );
};

export default HeaderControls;
